export const linedpaperWall = `\
-- lined paper
-- full-width rows, thin black lines

@unit 20px
@height 20px
@gap 1px
@mortar black
@color white
@shadow none

500
`
